<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Pay Group</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                    <div><span class="text-muted">Pay Group: </span>{{ paygroup.name }}</div>
                </div>
            </div>

            <paygroup-form
                ref="paygroupForm"
                :initial-value="formData"
            />

        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PaygroupForm from './PaygroupForm'

export default {
    props: ['client', 'paygroup', ],
    mixins: [FormMixin, ModalMixin],
    components: {PaygroupForm, },
    emits: ['updated', 'close', ],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.paygroup.company_id)
        },
    },
    methods: {
        makeFormData() {
            return {
                name: this.paygroup.name,
                pay_schedule: this.paygroup.pay_schedule,
                period_start: this.paygroup.period_start,
                period_end: this.paygroup.period_end,
                check_date_offset_1: this.paygroup.check_date_offset_1,
                check_date_offset_2: this.paygroup.check_date_offset_2,
                bank_holiday_treatment: this.paygroup.bank_holiday_treatment,
                weekend_treatment: this.paygroup.weekend_treatment,
            }
        },
        onSubmit() {
            if (!this.$refs.paygroupForm.validate()) {
                this.formErrors = this.$refs.paygroupForm.formErrors
                return
            }

            const data = this.$refs.paygroupForm.getFormData()

            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/paygroups/${this.paygroup.id}`
            this.$api.put(url, data).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully saved pay group details.`)
                this.$emit('updated', resp)
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>
